import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { find } from "lodash";
import { h } from "preact";
import { ApiBackedScComponent } from "../../common/components/ApiBackedScComponent";
import {
  MakeGenericApiCall,
  MakeSalesCreditRoleProfile,
} from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
} from "../../common/generic/generic-helper";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { IGenericRequest } from "../../common/generic/generic-types";
import { ConvertFilter } from "../../common/salescredit/salescredit-filter-help";
import {
  BuildSalesCreditFilters,
  CreateDateFromFilter,
} from "../../common/salescredit/salescredit-search-criteria";
import { IProps } from "../../common/salescredit/salescredit-types";
import { maxSelectedClients } from "../../common/utils/clientlistHelper";
import { Format } from "../../common/utils/format";
import { GetKpiDetails, MapGenericData } from "../utils/helper";

interface IState {
  data?: any;
}

export class SalesCreditFicIndicatorClass extends ApiBackedScComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  private readonly SalesCreditFicStyles = {
    DirectionColor: {
      down: {
        color: "#b9292d",
      },
      up: {
        color: "#35bd5b",
      },
    },
  };

  private readonly TempStyle = {
    Border: {
      outline: "#000000 solid 1px",
    },
    NoPadding: {
      padding: "10px 5px 5px 2px",
    },
  };

  constructor() {
    super();
    this.setState({
      data: {},
    });
  }
  public renderWithDataReady(): JSX.Element {
    return (
      <div class="container" style="width: 100%; height: 100%">
        <div class="row">
          <div class="col-xs-3 text-right" style={this.TempStyle.NoPadding}>
            <strong>MarkUp</strong>
          </div>
          <div class="col-xs-1 text-right" style={this.TempStyle.NoPadding}>
            <i
              class={Format.GetArrowClass(
                this.state.data.MarkUp_Ytd,
                this.state.data.MarkUp_Ytd1
              )}
              style={
                this.state.data.MarkUp_Ytd < this.state.data.MarkUp_Ytd1
                  ? this.SalesCreditFicStyles.DirectionColor.down
                  : this.SalesCreditFicStyles.DirectionColor.up
              }
              aria-hidden="true"
            />
          </div>
          <div class="col-xs-4 text-right" style={this.TempStyle.NoPadding}>
            {Format.FormatMoney(this.state.data.MarkUp_Ytd, 1000, 0)}
            &nbsp;K&euro;
          </div>
          <div class="col-xs-4 text-right" style={this.TempStyle.NoPadding}>
            <span
              style="width: 90%"
              class={Format.GetLabelClass(
                this.state.data.MarkUp_Ytd,
                this.state.data.MarkUp_Ytd1
              )}
            >
              {Format.CalculatePercentageChange(
                this.state.data.MarkUp_Ytd,
                this.state.data.MarkUp_Ytd1,
                0,
                false
              )}
              &nbsp;%&nbsp;YoY
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-3 text-right" style={this.TempStyle.NoPadding}>
            <strong>F(Y)</strong>
          </div>
          <div class="col-xs-1 text-right" style={this.TempStyle.NoPadding}>
            <i
              class={Format.GetArrowClass(
                this.state.data.F2Y_Ytd,
                this.state.data.F2Y_Ytd1
              )}
              style={
                this.state.data.F2Y_Ytd < this.state.data.F2Y_Ytd1
                  ? this.SalesCreditFicStyles.DirectionColor.down
                  : this.SalesCreditFicStyles.DirectionColor.up
              }
              aria-hidden="true"
            />
          </div>
          <div class="col-xs-4 text-right" style={this.TempStyle.NoPadding}>
            {Format.FormatMoney(this.state.data.F2Y_Ytd, 1000, 0)}
            &nbsp;K&euro;
          </div>
          <div class="col-xs-4 text-right" style={this.TempStyle.NoPadding}>
            <span
              style="width: 90%"
              class={Format.GetLabelClass(
                this.state.data.F2Y_Ytd,
                this.state.data.F2Y_Ytd1
              )}
            >
              {Format.CalculatePercentageChange(
                this.state.data.F2Y_Ytd,
                this.state.data.F2Y_Ytd1,
                0,
                false
              )}
              &nbsp;%&nbsp;YoY
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-3 text-right" style={this.TempStyle.NoPadding}>
            <strong>CVA</strong>
          </div>
          <div class="col-xs-1 text-right" style={this.TempStyle.NoPadding}>
            <i
              class={Format.GetArrowClass(
                this.state.data.CVA_Ytd,
                this.state.data.CVA_Ytd1
              )}
              style={
                this.state.data.CVA_Ytd < this.state.data.CVA_Ytd1
                  ? this.SalesCreditFicStyles.DirectionColor.down
                  : this.SalesCreditFicStyles.DirectionColor.up
              }
              aria-hidden="true"
            />
          </div>
          <div class="col-xs-4 text-right" style={this.TempStyle.NoPadding}>
            {Format.FormatMoney(this.state.data.CVA_Ytd, 1000, 0)}
            &nbsp;K&euro;
          </div>
          <div class="col-xs-4 text-right" style={this.TempStyle.NoPadding}>
            <span
              style="width: 90%"
              class={Format.GetLabelClass(
                this.state.data.CVA_Ytd,
                this.state.data.CVA_Ytd1
              )}
            >
              {Format.CalculatePercentageChange(
                this.state.data.CVA_Ytd,
                this.state.data.CVA_Ytd1,
                0,
                false
              )}
              &nbsp;%&nbsp;YoY
            </span>
          </div>
        </div>
      </div>
    );
  }

  protected shouldFetchApiData(nextProps: IProps): boolean {
    return true;
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    this.setDataStatus("loading");
    const userRole = await MakeSalesCreditRoleProfile(
      props.headers,
      this.props.widgetConfiguration,
      undefined,
      this.state.correlationId
    );
    if (userRole.Role === undefined) {
      this.setDataStatus("no-access-rights");
      this.setStatusText(userRole.StatusText);
      return;
    }

    const filtersConverted = ConvertFilter(props.filters);
    const filters = BuildSalesCreditFilters(filtersConverted);

    const genericRequest: IGenericRequest = {
      date: CreateDateFromFilter(filtersConverted),
      filter: GenericFilterBuilder(filters),
      kpis: GetKpiDetails(userRole).join(","),
    };
    const filterClientsSelected = find(filters, {
      attribute: "clientgen_id",
    });
    const clientsCount = filterClientsSelected
      ? filterClientsSelected.value.split("+").length
      : 0;
    if (filterClientsSelected && clientsCount >= maxSelectedClients) {
      this.setState({
        data: [],
      });
      this.setDataStatus("too-many-clients");
    } else {
      const result = await MakeGenericApiCall(
        props.headers,
        "sc",
        genericRequest,
        this.props.widgetConfiguration,
        this.state.correlationId
      );
      const errorStatus = CheckReponseDataForError(result);
      if (errorStatus) {
        this.setDataStatus(errorStatus);
        this.setStatusText(result.statusText);
        this.setState({
          data: undefined,
        });
        return;
      }

      const mapData = MapGenericData(userRole, result);
      if (mapData !== undefined) {
        this.setState({
          data: mapData,
        });
        this.setDataStatus("ready");
      } else {
        this.setState({
          data: undefined,
        });
        this.setDataStatus("no-data");
      }
    }
  }
}
export const SalesCreditFicIndicator = withWidgetConfiguration(
  SalesCreditFicIndicatorClass
);
